import React from 'react';
import SupportTicketForm from './SupportTicketForm';
import { Seo } from '../../../core/seo';

const SupportTicketPage: React.FC = () => {
  return (
    <>
      <Seo
        title="Support"
        description="Need help? Contact HirePanther support. Submit a ticket and our team will assist you with any questions about booking, providers, or your account."
        canonicalPath="/support-ticket"
      />
      <SupportTicketForm />
    </>
  );
};

export default SupportTicketPage;
